import { Grid, Row, Col } from "@vds/grids";
import { Body } from "@vds/typography";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import getSingleDeviceProfile from "../../DeviceProfile/utility/getSingleDeviceProfile";
import {
  fetchalllocationRequest,
  fetchDeviceTypeRequest,
  updateUI,
} from "../../../store/actions/deviceProfile";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { fetchSingleDeviceTypesRequest } from "../../../store/actions/asset";
import { useEffect } from "react";
import capitalizeFirstLetter from "../../../global/utility/capitalizeFirstLetter";

dayjs.extend(relativeTime);

function AssetDetails() {
  const dispatch = useDispatch();
  const { RSSI, deviceData } = useSelector((state) => ({
    RSSI: {
      isLoading: state?.shipmentDashboard?.isLoading?.rssi,
      data: state?.shipmentDashboard?.data?.rssiHistory?.rssi || [],
    },
    deviceData: state?.asset?.data?.deviceDetails || {},
  }));

  const rssiValue =
    Array.isArray(RSSI.data) &&
    RSSI.data.length > 0 &&
    Array.isArray(RSSI.data[RSSI.data.length-1]) &&
    RSSI.data[0].length > 1
      ? RSSI.data[RSSI.data.length-1][1]
      : "N/A";
  const {
    asset,
    isLoading,
    deviceProfiles,
    currentDeviceProfile,
    deviceTypes,
    isDeviceProfileLoading,
  } = useSelector((state) => {
    let currentDeviceProfile = {
      isDeleted: false,
      profilename: null,
    };
    let asset =
      Array.isArray(state?.asset?.data?.assetList) &&
      state?.asset?.data?.assetList.length > 0
        ? state?.asset?.data?.assetList[0]
        : {};
    if (
      Array.isArray(state?.deviceProfile?.data?.devices) &&
      state?.deviceProfile?.data?.devices.length > 0
    ) {
      const filteredProfiles = state?.deviceProfile?.data?.devices.filter(
        (profile) => profile.profileid === asset?.deviceprofile?.id
      );

      if (filteredProfiles.length > 0 && filteredProfiles[0]?.profilename) {
        currentDeviceProfile = {
          isDeleted: false,
          profilename: filteredProfiles[0]?.profilename,
        };
      } else {
        currentDeviceProfile = {
          isDeleted: true,
          profilename: asset?.deviceprofile?.profilename || null,
        };
      }
    }
    return {
      asset,
      isLoading: state?.asset?.isLoading?.assetList,
      deviceProfiles: state?.deviceProfile?.data?.devices || [],
      deviceTypes: state.deviceProfile.ui.form.deviceTypes,
      isDeviceProfileLoading: state?.deviceProfile?.isLoading.devices,
      currentDeviceProfile,
    };
  });

  const handleViewProfile = (id) => {
    //dispatch(fetchalllocationRequest());
    dispatch(fetchDeviceTypeRequest());
    const singleDeviceProfile = getSingleDeviceProfile(
      deviceProfiles,
      id,
      deviceTypes
    );
    if (singleDeviceProfile === null) return;
    dispatch(
      updateUI({
        key: "form",
        value: {
          isOpen: true,
          type: "view",
          step: -1,
          ...singleDeviceProfile,
        },
      })
    );
  };
  useEffect(() => {
    if (asset?.devicetype && !isLoading) {
      dispatch(fetchSingleDeviceTypesRequest(asset?.devicetype));
    }
  }, [dispatch]);

  return (
    <Spin spinning={isLoading || isDeviceProfileLoading}>
      <div className="ats-asset-details">
        <Grid
          colSizes={{
            mobile: 1,
            tablet: 2,
            desktop: 3,
          }}
          expanded
        >
          <Row>
            <Col>
              <div className="ats-asset-details-border">
                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Asset type
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {asset?.assettype || "N/A"}
                  </Body>
                </div>

                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Asset model
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {asset?.assetmodel || "N/A"}
                  </Body>
                </div>

                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Asset serial number
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {asset?.assetserialnumber || "N/A"}
                  </Body>
                </div>
              </div>
            </Col>
            <Col>
              <div className="ats-asset-details-border">
                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Device profile
                  </Body>
                  {currentDeviceProfile?.isDeleted ? (
                    <Body size="large" color="#000" bold={false}>
                      {currentDeviceProfile?.profilename || "N/A"}
                    </Body>
                  ) : (
                    <button
                      className="ats-btn-link"
                      style={{ color: "black" }}
                      onClick={() => {
                        handleViewProfile(asset?.deviceprofile?.id);
                      }}
                    >
                      <Body size="large" color="#000" bold={false}>
                        {currentDeviceProfile?.profilename}
                      </Body>
                    </button>
                  )}
                </div>

                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Device model
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {asset?.devicetype || "N/A"}
                  </Body>
                </div>

                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Device name
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {deviceData?.name || "N/A"}
                  </Body>
                </div>
              </div>
            </Col>
            <Col>
              <div className="ats-asset-details-border">
                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Assigned location
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {(() => {
                      if (!asset?.location) return "Not Assigned";

                      const locations = [];

                      if (asset?.location?.name) {
                        locations.push(
                          capitalizeFirstLetter(asset?.location?.name)
                        );
                      }

                      if (asset?.location?.floor?.name) {
                        locations.push(
                          capitalizeFirstLetter(asset?.location?.floor?.name)
                        );
                      }

                      if (asset?.location?.floor?.zone?.zone_name) {
                        locations.push(
                          capitalizeFirstLetter(
                            asset?.location?.floor?.zone?.zone_name
                          )
                        );
                      }

                      return locations?.length > 0
                        ? locations.join(" - ")
                        : asset?.location?.address || "Not Assigned";
                    })()}
                  </Body>
                </div>

                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Current location
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {(() => {
                      if (!asset?.currentlocation) return "Unknown";

                      const locations = [];

                      if (asset?.currentlocation?.name) {
                        locations.push(
                          capitalizeFirstLetter(asset?.currentlocation?.name)
                        );
                      }

                      if (asset?.currentlocation?.floor?.name) {
                        locations.push(
                          capitalizeFirstLetter(
                            asset?.currentlocation?.floor?.name
                          )
                        );
                      }

                      if (asset?.currentlocation?.floor?.zone?.zone_name) {
                        locations.push(
                          capitalizeFirstLetter(
                            asset?.currentlocation?.floor?.zone?.zone_name
                          )
                        );
                      }

                      return locations?.length > 0
                        ? locations.join(" - ")
                        : asset?.location?.address || "Unknown";
                    })()}
                  </Body>
                </div>
                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    RSSI
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {rssiValue}
                  </Body>
                </div>
              </div>
            </Col>
            <Col>
              <div>
                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Last updated
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {asset?.updatedat
                      ? dayjs(asset?.updatedat).fromNow()
                      : "N/A"}
                  </Body>
                </div>

                <div className="ats-asset-details-col">
                  <Body size="medium" color="#6F7171" bold={true}>
                    Created date
                  </Body>
                  <Body size="large" color="#000" bold={false}>
                    {asset?.createdon
                      ? dayjs(asset?.createdon).format("MMM D, YYYY h:mm A")
                      : ""}
                  </Body>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    </Spin>
  );
}

export default AssetDetails;
